import { Control, FieldErrors, UseFormSetValue } from "react-hook-form";
import { direccionGarantia } from "../../models/garantias";
import { selectorTransversal } from "../../../../dtos/selector";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import { Grid2 } from "@mui/material";

interface IProps {
    control: Control<direccionGarantia, undefined>;
    ciudades: selectorTransversal[];
    comunas: selectorTransversal[];
    hipotecas: selectorTransversal[];
    listEstadoBienRaiz: selectorTransversal[];
    comunaPorId: (idCiudad: string) => Promise<void>;
    isEditing: boolean;
    errors: FieldErrors<direccionGarantia>;
    setValue: UseFormSetValue<direccionGarantia>;
    esVigente?: boolean;
    permisoCarteraMutuoEditarInfo: boolean;
}

const DireccionForm: React.FC<IProps> = (props) => {
    const { isEditing, permisoCarteraMutuoEditarInfo, esVigente } = props;
    const handleCiudadComuna = async (id: string | null) => {
        if (id) {
            props.setValue('comuna', '', { shouldDirty: true });
            await props.comunaPorId(id);
        }
    }
    const isReadonlyWithPermission = () => {
        let result = !isEditing || (esVigente && !permisoCarteraMutuoEditarInfo);
        return result ?? true;
    }
    return (

        <Grid2 container spacing={2} mt={2}>
            <Grid2 size={{ xs: 12, lg: 3 }}>
                <InputText
                    desabilitado={isReadonlyWithPermission()}
                    label="Rol propiedad"
                    name="rolPropiedad"
                    control={props.control}
                    error={props.errors.rolPropiedad}
                />
            </Grid2>

            <Grid2 size={{ xs: 12, lg: 3 }}>
                <InputText
                    desabilitado={isReadonlyWithPermission()}
                    label="Dirección propiedad"
                    name="direccionParticular"
                    control={props.control}
                    error={props.errors.direccionParticular}
                />
            </Grid2>

            <Grid2 size={{ xs: 12, lg: 3 }}>
                <InputSelect
                    readonly={isReadonlyWithPermission()}
                    label="Ciudad"
                    name="ciudad"
                    control={props.control}
                    options={props.ciudades}
                    onChange={(value) => handleCiudadComuna(value ?? '')}
                    error={props.errors.ciudad}
                />
            </Grid2>

            <Grid2 size={{ xs: 12, lg: 3 }}>
                <InputSelect
                    readonly={isReadonlyWithPermission()}
                    label="Comuna"
                    name="comuna"
                    control={props.control}
                    options={props.comunas}
                    error={props.errors.comuna}
                />
            </Grid2>
        </Grid2>

    );

};

export default DireccionForm;